import { Button, Grid, Typography } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useSuperAdminSingleOrg } from "../../context/SuperAdmin/SingleOrgContext";
import { Spinner } from "../../components/Loading/Spinner";
import { useNavigate } from "react-router-dom";
import TabsSingleOrg from "../../components/Table/Organization/TabsSingleOrg";

export const SingleOrgPage = () => {
  const { isLoadingOrg, organization } = useSuperAdminSingleOrg();
  const navigate = useNavigate();
  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button sx={{ color: "#336B87" }} onClick={() => navigate(-1)}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {isLoadingOrg ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Título */}
          <Grid item>
            <Typography
              variant={"h4"}
              sx={{ color: "#005559", fontSize: "30px" }}
            >
              <b>Organización</b> | {organization?.nombre}
            </Typography>
          </Grid>

          {/* Sección de Tabs */}
          <Grid item>
            <TabsSingleOrg />
          </Grid>
        </>
      )}
    </Grid>
  );
};
